import { Chip, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';

const PreviousYearInfo = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);

  return (
    <Styled.Container align="flex-start" justify="center" gap="dimension_08">
      <Chip size="S" type="success_line">
        {t('Result.previousYear.text')}
      </Chip>
      <Text type="paragraphs" size="S_M_S" color="dark">
        {t('Result.previousYear.description')}
      </Text>
    </Styled.Container>
  );
};

export default PreviousYearInfo;
